<template>
  <div class="blocks">
    <approach></approach>
    <philosophy></philosophy>
    <callout></callout>
    <experience></experience>
  </div>
</template>

<script>
import approach from '@/components/approach';
import philosophy from '@/components/philosophy';
import callout from '@/components/callout';
import experience from '@/components/experience';
export default {
  name: 'blocks',
  components: {
      approach,
      philosophy,
      callout,
      experience
  }
}
</script>

<style lang="sass" scoped>

</style>